var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warp"},[_c('div',{staticClass:"detail"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.detail.title))]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.detail.content)}})]),_c('el-button',{staticClass:"but",attrs:{"type":"primary"},on:{"click":_vm.toBack}},[_vm._v(" 关闭")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }